module.exports = __webpack_public_path__ + "img/7e49329b-38c4-4871-a352-383b64b60c6a.4b8a0f5d.png";